import { render, staticRenderFns } from "./lcIframe.vue?vue&type=template&id=608bb21d&scoped=true"
import script from "./lcIframe.vue?vue&type=script&lang=js"
export * from "./lcIframe.vue?vue&type=script&lang=js"
import style0 from "./lcIframe.vue?vue&type=style&index=0&id=608bb21d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608bb21d",
  null
  
)

export default component.exports